import { cn } from '../../../../utilities/cn';

const PeriodCaption = ({
  className,
  children = 'Within chosen period',
}: {
  className?: string;
  children?: string;
}) => (
  <div
    className={cn(
      'absolute right-3 top-2 text-[10px] italic leading-none text-gray-400',
      className,
    )}
  >
    {children}
  </div>
);

export default PeriodCaption;
